import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import MembershipPaymentFlow from './views/membership-payment-flow/MembershipPaymentFlow/MembershipPaymentFlow'
import SignupFlow from './views/signup-flow/SignupFlow/SignupFlow'

console.log(`MyNTUC Web Components`)

if (document.getElementById(`signup-flow`)) {
    console.log(`Found the "signup-flow" container. Loading React component.`)
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback="loading...">
                <SignupFlow />
            </Suspense>
        </React.StrictMode>,
        document.getElementById(`signup-flow`),
    )
    console.log(`"signup-flow" component has been loaded.`)
} else {
    console.log(`The "signup-flow" component was not found`)
}

if (document.getElementById(`membership-payment`)) {
    console.log(`Found the "membership-payment" container. Loading React component.`)
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback="loading...">
                <MembershipPaymentFlow />
            </Suspense>
        </React.StrictMode>,
        document.getElementById(`membership-payment`),
    )
    console.log(`"membership-payment" component has been loaded.`)
} else {
    console.log(`The "signup-flow" component was not found`)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
